import { Interface } from '@ethersproject/abi'
import { BigNumber } from '@ethersproject/bignumber'
import { MERKLE_TIME_RELEASE_ABI, TIME_RELEASE_ABI } from '../constants'
import { CurrencyValue } from '../model'
import { TimeReleaseClaim } from '../hooks'

export function getTimeReleaseClaimTransaction(
  account: string,
  timeReleaseAddress: string,
  option1Claimable: CurrencyValue,
  option2Claimable: CurrencyValue
) {
  const txInfo = {
    type: 'CLAIM',
    option1: option1Claimable.format(),
    option2: option2Claimable.format(),
  } as const
  return {
    to: timeReleaseAddress,
    data: new Interface(TIME_RELEASE_ABI).encodeFunctionData('claim', [account]),
    value: BigNumber.from(0),
    txInfo,
  }
}

export function getMerkleTimeReleaseClaimTransaction(
  account: string,
  timeReleaseAddress: string,
  option1Claimable: CurrencyValue,
  option2Claimable: CurrencyValue,
  timeReleaseClaim: TimeReleaseClaim
) {
  const txInfo = {
    type: 'CLAIM',
    option1: option1Claimable.format(),
    option2: option2Claimable.format(),
  } as const
  return {
    to: timeReleaseAddress,
    data: new Interface(MERKLE_TIME_RELEASE_ABI).encodeFunctionData('initializeAndClaim', [
      account,
      timeReleaseClaim.amount1,
      timeReleaseClaim.amount2,
      timeReleaseClaim.proof,
    ]),
    value: BigNumber.from(0),
    txInfo,
  }
}
